import React, { useEffect } from 'react';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

export const IFramePopup = ({ data, id, title }) => {
  const { messageHandler, url, allow = '' } = data;

  useEffect(() => {
    if (typeof messageHandler !== 'function') {
      return;
    }

    const iframeURL = new URL(url);

    const eventHandler = event => {
      if (event.origin === iframeURL.origin) {
        messageHandler(event.data);
      }
    };

    window.addEventListener('message', eventHandler);

    return () => window.removeEventListener('message', eventHandler);
  }, [messageHandler, url]);

  return (
    <DefaultPopup
      className="popup-iframe"
      headerTitle={title}
      onClose={() => NotificationManager.removeNotification(id)}
    >
      <div className="popup__content">
        <iframe allow={allow} src={url} />
      </div>
    </DefaultPopup>
  );
};
